import api from "../../Api/feathers-client";

// Call backend service to get all assignments
export const getAssignmentList = async (
  loggedInUser,
  site_uuid,
  skip,
  limit,
  query = {}
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").find({
        query: {
          ...query,
          created_by: loggedInUser,
          site_uuid: site_uuid,
          is_deleted: false,
          $sort: {
            created_at: -1,
          },
          $skip: skip,
          $limit: limit,
        },
      });

      resolve({
        status: 200,
        message: "All Assignment",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get selected assignment
export const getAssignmentInfo = async (uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").find({
        query: {
          uid: uid,
          site_uuid: site_uuid,
          is_deleted: false,
        },
      });

      resolve({
        status: 200,
        message: "All Assignments",
        data: response["data"],
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get selected assignment learners
export const getAssignmentLearners = async (
  learner_ids,
  site_uuid,
  status = [true]
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find({
        query: {
          $select: [
            "uid",
            "name",
            "role_uid",
            "avatar",
            "belongs_to",
            "roll_no",
            "status",
          ],
          status: status,
          uid: {
            $in: learner_ids,
          },
          site_uuid: site_uuid,
          $limit: -1,
        },
      });

      resolve({
        status: 200,
        message: "All Learners",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get all tasks
export const getTaskList = async (loggedInUser, site_uuid, productId, type) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("tasks").find({
        query: {
          $select: ["uid", "title", "estimated_time", "data1"],
          created_by: loggedInUser,
          site_uuid: site_uuid,
          product_uid: type.toLowerCase() == "media" ? null : productId,
          is_deleted: false,
          tasktype: type,
          $sort: {
            created_at: -1,
          },
          $limit: -1,
        },
      });

      console.log("response", response);

      resolve({
        status: 200,
        message: "All Task",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to update assignment
export const updateAssignment = async (data, uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").patch(null, data, {
        query: {
          uid,
          site_uuid,
        },
      });

      resolve({
        status: 200,
        message: "Assignment Updated",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get learners of selected class
export const getClassLearners = async (class_ids, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find({
        query: {
          $select: [
            "uid",
            "name",
            "role_uid",
            "avatar",
            "belongs_to",
            "roll_no",
          ],
          belongs_to: {
            $in: class_ids,
          },
          status: true,
          site_uuid: site_uuid,
          $limit: -1,
        },
      });

      resolve({
        status: 200,
        message: "All Learners",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to create assignment
export const createAssignment = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").create(data, {});

      resolve({
        status: 200,
        message: "Assignment Created",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get all tasks
export const getTaskListFromUid = async (uid, site_uuid, mode) => {
  return new Promise(async (resolve, reject) => {
    try {
      let mainQuery = {
        $select: [
          "uid",
          "title",
          "estimated_time",
          "product_uid",
          "tasktype",
          "data1",
        ],
        uid: uid,
        site_uuid: site_uuid,
        $sort: {
          created_at: -1,
        },
        $limit: -1,
      };
      let response = await api.service("tasks").find({
        query:
          mode == "edit"
            ? mainQuery
            : {
                ...mainQuery,
                is_deleted: false,
              },
      });

      resolve({
        status: 200,
        message: "All Task",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get learners of selected class
export const getLearnersFromUid = async (uids, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("users").find({
        query: {
          $select: [
            "uid",
            "name",
            "role_uid",
            "avatar",
            "belongs_to",
            "roll_no",
          ],
          status: true,
          uid: uids,
          site_uuid: site_uuid,
          $limit: -1,
        },
      });

      resolve({
        status: 200,
        message: "All Learners",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// Call backend service to get learners of selected class
export const getAssignFromTitle = async (title, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignments").find({
        query: {
          $select: ["uid"],
          is_deleted: false,
          title: title,
          site_uuid: site_uuid,
          $limit: -1,
        },
      });

      resolve({
        status: 200,
        message: "Assignment",
        data: response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};
